import script from "./overstocklist.vue?vue&type=script&setup=true&lang=ts"
export * from "./overstocklist.vue?vue&type=script&setup=true&lang=ts"

import "./overstocklist.vue?vue&type=style&index=0&id=1e962a76&lang=scss&scoped=true"

import exportComponent from "E:\\svn\\xmTask(国振资产管理)1\\views\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e962a76"]])

export default __exports__